export class MainTimesheet {
    id!: number;
    month!: number;
    year!: number;
    status!: string;
    employeeId!: number;
    firstName!: string;
    lastName!: string;
    reason!: string;
    preriodFrom: Date;
    preriodTo: Date;
    positionName: string;
    positionId!: number;
    revise: string;
    leadId!: number;
    userStatus!: string;
    nickNameTh!: string;
    leadName!: string;
    leadNickNameTh!: string;
    reviseBy?: number;    
    reviseDate?: Date;      
}